import { ReputationSchema } from '../../models/reputation';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/** The character's standing with each power that knows of it (CHAR-REPUTATION). */
export const getReputation = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/character/reputation`,
  access: 'session',
  response: ReputationSchema,
});
